export enum USER_TYPES {
	CLIENT = 'Client',
	RESELLER = 'Reseller',
	SUB_ACCOUNT = 'SubAccount',
}
